import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';

export function createStateFromHtml(html: string) {
  const blockContent = htmlToDraft(html);
  if (blockContent.contentBlocks) {
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blockContent.contentBlocks,
        blockContent.entityMap,
      ),
    );
  }

  return EditorState.createEmpty();
}
